import { tag } from "./tag";
import { vote } from "./vote";
import { votestats } from "./votestats";

export type post = {
    _id: string;
    title: string;
    description: string;
    surveyText: string;
    rawdata: string;
    delivered: boolean;
    tags: tag[];
    deliveryDate?: Date;
    hasYesNoQuestion: boolean;
    imagebase64: string;
    htmlContent?: any;
    loaded?: boolean;
    votes?: Array<vote>;
    votestats?: votestats;
}
export const defaultPost = (): post => ({
    _id: "",
    title: "",
    description: "",
    surveyText: "",
    rawdata: "",
    delivered: false,
    tags: new Array<tag>(),
    hasYesNoQuestion: false,
    imagebase64: ``
})